import { GridColDef } from '@mui/x-data-grid-premium';
import React, { useEffect, useState } from 'react';
import tableHelper from 'src/utils/tableHelper';
import { tableSettingsProps, useCompleteTableSettings, useInitialTableSettings, useTableSettings } from '../tableSettings/useTableSettings';
import { useGetAllDiscontinuedSalesItems, useGetAllSalesItems, useGetSalesItemAttributeReferenceData, useGetSalesItemAttributes } from '../../api/requestConfigs/salesitems';
import { useGetAttributesByProductType } from '../../api/requestConfigs/products';
import { AttibuteInputCell, attributeToUpdateProps } from 'src/components/molecules/table/AttributeInputCell';
import useUpdateEffect from '../../useUpdateEffect';
import useRequest from '../../api/useRequest';
import { getCampaignReportSalesItemsThisMonth } from 'src/utils/apiRequests';
import { Select, MenuItem } from '@mui/material';
import ThumbnailCell from 'src/components/molecules/table/ThumbnailCell';

export const useSalesItemsTable = (includeDiscontinued: boolean = false): [columns: GridColDef[], tableSettings: tableSettingsProps] => {

  const {rows: activeRows, status: activeStatus} = useGetAllSalesItems();
  const {rows: discontinuedRows, status: discontinuedStatus} = useGetAllDiscontinuedSalesItems(includeDiscontinued);
console.log("discontinuedRows", discontinuedRows,"activeRows", activeRows)
  const rows = React.useMemo(() => {
    if (!includeDiscontinued) return activeRows;
    return tableHelper.mergeById(activeRows, discontinuedRows, "ArticleNumber");
  }, [includeDiscontinued, activeRows, discontinuedRows]);

  const status = includeDiscontinued ? (discontinuedStatus === "success" ? activeStatus : discontinuedStatus) : activeStatus;

  //console.log(rows)
  const idPath = ["ArticleNumber"];
  const [campaingRows, setRequest, abort] = useRequest();
  useUpdateEffect(() => {
    setRequest(getCampaignReportSalesItemsThisMonth())
  }, [rows])
  const campaignCell = (params) => {
    let campaingCellInfo = 0;
    const matchinCampaingRows = campaingRows?.ReportRows?.filter(campaingRow => campaingRow.SalesItemId == params.id);
    matchinCampaingRows?.forEach(row => {
      campaingCellInfo += parseInt(row?.QuantitySold ?? 0);
    })
    return campaingCellInfo;
  }
  const [tableDensity, setTableDensity] = useState(null);
  //const manufacturerOptions = tableHelper.getSelectOptions(rows, "ManufacturerName");
  const columns: GridColDef[] = React.useMemo(
    () => [
      { field: 'actions', getActions: (params) => tableHelper.buttonColumn(params, "Edit", "/products/sales-items/edit?id=", "ArticleNumber", "Edit Sales Item"), type: 'actions', headerName: 'Edit', minWidth: 80, maxWidth: 120, flex: 0.8, },
      { field: 'ArticleNumber', headerName: 'Sku', hideable: false, width: 90, minWidth: 80, maxWidth: 100 },
      { field: 'Name', editable: true, headerName: 'Name', width: 400, minWidth: 175 },
      {
        field: 'ImageResourceId', editable: false, headerName: 'Thumbnail', width: 100, cellClassName: 'thumbnail-cell',
        // sortComparator: imageIdComparator,
        // filterOperators: [customThumbnailFilterOperator],

        renderCell: (params) => <ThumbnailCell params={params} tableDensity={tableDensity} />

      },
      { field: 'Status_Value', headerName: 'Status', valueGetter: tableHelper.getFieldKeyOrValue, groupingValueGetter: tableHelper.getFieldKeyOrValue, width: 115, minWidth: 100, maxWidth: 130, renderCell: tableHelper.renderStatusCell, type: 'singleSelect', valueOptions: tableHelper.STATUSES.SALES_ITEMS, getApplyQuickFilterFn: undefined, },
      { field: 'AvailableQty', headerName: 'Qty', type: "number", width: 80, minWidth: 60, maxWidth: 100, aggregable: true },
      { field: 'ProductType_Value', headerName: 'Product Type', valueGetter: tableHelper.getFieldKeyOrValue, width: 150, minWidth: 100, maxWidth: 180 },
      { field: 'ProductType_Key', headerName: 'Product Type Id', valueGetter: tableHelper.getFieldKeyOrValue, width: 130, minWidth: 100, maxWidth: 160 },
      { field: 'Manufacturer_Value', headerName: 'Manufacturer', valueGetter: tableHelper.getFieldKeyOrValue, width: 200, minWidth: 150, maxWidth: 280 }, // type: 'singleSelect', getApplyQuickFilterFn: undefined, valueOptions: manufacturerOptions,
      { field: 'ManufacturerProductId', headerName: 'Manufacturer Product Id', width: 200, minWidth: 150, maxWidth: 250 },
      { field: 'ValidFrom', type: 'dateTime', valueGetter: tableHelper.getDateColumn, headerName: 'Valid From', width: 115, minWidth: 100, maxWidth: 200 },
      { field: 'ValidTo', type: 'dateTime', valueGetter: tableHelper.getDateColumn, headerName: 'Valid To', width: 115, minWidth: 100, maxWidth: 200 },
      { field: 'Created', type: 'dateTime', valueGetter: tableHelper.getDateColumn, headerName: 'Created', width: 115, minWidth: 100, maxWidth: 200 },
      { field: 'Modified', type: 'dateTime', valueGetter: tableHelper.getDateColumn, headerName: 'Modified', width: 115, minWidth: 100, maxWidth: 200 },
      { field: 'SalesItemType_Value', headerName: 'Sales Item Type', valueGetter: tableHelper.getFieldKeyOrValue, width: 125 },
      { field: 'SalesItemType_Key', headerName: 'Sales Item Type Id', valueGetter: tableHelper.getFieldKeyOrValue, width: 135 },
      { field: 'ProductLine', headerName: 'Product Line', },
      { field: 'OptionGroup', headerName: 'Option Group' },
      { field: 'ProductClass', headerName: 'Product Class', },
      { field: 'ProductSubClass', headerName: 'Product Subclass', },
      { field: 'SalesItemId', headerName: 'Sales Item Id', },
      { field: 'Manufacturer_Key', headerName: 'Manufacturer Id', valueGetter: tableHelper.getFieldKeyOrValue, },
    ],
    [, campaingRows, rows],
  );
  const tableName = "SalesItemsTable";
  let tableSettings = useTableSettings({ columns, rows, idPath, tableName ,status});
  //console.log(tableSettings.columnVisibilityModel)
  useEffect(() => {
    setTableDensity(tableSettings?.density ?? null);
  }, [tableSettings?.density])
  tableSettings.initalSorting = [{ field: "ArticleNumber", sort: 'desc' }];
  useEffect(() => {
    tableSettings.setColumnVisibilityModel({
      ProductType_Key: false,
      ManufacturerProductId: false,
      SalesItemType_Key: false,
      ProductLine: false,
      OptionGroup: false,
      ProductClass: false,
      ProductSubClass: false,
      SalesItemId: false,
      Manufacturer_Key: false,
    });
  }, []);
  
  tableSettings.hasToolbar = true;
  return [columns, tableSettings];
};



export const useSalesItemsOnProductsTable = (initialValues): [columns: GridColDef[], tableSettings: tableSettingsProps] => {
  const [rows, setRows] = useState([])
  const idPath = ["SalesItemId"];
  useUpdateEffect(() => {
    if (rows?.length < 1) {
      setRows(initialValues?.SalesItems ?? [])
    }
  }, [initialValues?.SalesItems])
  const columns: GridColDef[] = React.useMemo(
    () => [
      { field: 'actions', getActions: (params) => tableHelper.buttonColumn(params, "Edit", "/products/sales-items/edit?id=", "ArticleNumber", "Edit Sales Item"), type: 'actions', headerName: 'Edit', minWidth: 80, maxWidth: 120, flex: 0.8, },
      { field: 'ArticleNumber', headerName: 'Sku', hideable: false },
      { field: 'SalesItemName', editable: true, headerName: 'Name', flex:1 },
      { field: 'SalesItemStatus_Value', headerName: 'Status', renderCell:tableHelper.renderStatusCell, valueGetter: tableHelper.getFieldKeyOrValue, },
      { field: 'MainItem', headerName: 'Main Item', type: "boolean" },
      { field: 'ManufacturerName', headerName: 'Manufacturer Name' },
      { field: 'ManufacturerProductId', headerName: 'Manufacturer Product Id' },
      { field: 'ProductType_Value', headerName: 'Product Type', valueGetter: tableHelper.getFieldKeyOrValue, },
      { field: 'ProductClass', headerName: 'Product Class', },
      { field: 'ProductSubClass', headerName: 'Product Subclass', },
      { field: 'SalesItemValidFrom', minWidth: 180, type: 'dateTime', valueGetter: tableHelper.getDateColumn, headerName: 'ValidFromDate' },
      { field: 'SalesItemValidTo', minWidth: 180, type: 'dateTime', valueGetter: tableHelper.getDateColumn, headerName: 'ValidToDate' },
      { field: 'ProductType_Key', headerName: 'Product Type Id', valueGetter: tableHelper.getFieldKeyOrValue, },
      { field: 'SalesItemId', headerName: 'Sales Item Id' },
    ],
    [],
  );
  const tableName = "SalesItemOnProductsTable";
  const tableSettings = useTableSettings({ columns, idPath, rows, tableName });
useEffect(() => {
  tableSettings.setColumnVisibilityModel({
    ManufacturerProductId: false,
    ProductType_Key: false,
    SalesItemId: false,
  });
}, []);

  tableSettings.loading = false;
  tableSettings.hasToolbar = false;
  tableSettings.autoHeight = true;
  return [columns, tableSettings];
};





export const useSalesItemAttributesTable = (editId): [
  columns: GridColDef[],
  tableSettings: tableSettingsProps,
  attributesToUpdate: attributeToUpdateProps[],
  applySavedAttributes: (savedAttributes: any) => void,
] => {
  const apiRows = useGetSalesItemAttributes(editId);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    setRows(apiRows ?? []);
  }, [apiRows]);

  const idPath = ["Attribute", "Key"];

  const addLeadingZeroIfNeeded = (value: any) => {
    if (value == null) return value;
    if (value?.startsWith(",") && !isNaN(Number(value?.substring(1)))) { return "0" + value; }
    return value;
  };

  const [attributesToUpdate, setAttributesToUpdate] = useState([
    { Id: "ProductId", Value: editId },
  ]);

  const applySavedAttributes = (savedAttributes: any) => {
    const savedRows = Array.isArray(savedAttributes?.AttributeValues)
      ? savedAttributes.AttributeValues
      : Array.isArray(savedAttributes)
        ? savedAttributes
        : [];

    if (!savedRows.length) {
      setAttributesToUpdate([{ Id: "ProductId", Value: editId }]);
      return;
    }

    setRows((currentRows: any[]) =>
      currentRows.map((row: any) => {
        const rowAttributeId = row?.Attribute?.Key ?? row?.Attribute_Key ?? row?.AttributeId ?? row?.Id;

        const saved = savedRows.find((savedRow: any) => {
          const savedAttributeId = savedRow?.AttributeId ?? savedRow?.Attribute?.Key ?? savedRow?.Attribute_Key ?? savedRow?.Id;
          return String(savedAttributeId) === String(rowAttributeId);
        });

        if (!saved) return row;

        return {
          ...row,
          AttributeValue: saved?.AttributeValue ?? row?.AttributeValue,
          DisplayUnit: saved?.DisplayUnit ?? row?.DisplayUnit,
          Comment: saved?.Comment ?? row?.Comment,
        };
      })
    );

    setAttributesToUpdate([{ Id: "ProductId", Value: editId }]);
  };

  const [productType, setProductType] = useState();

  useEffect(() => {
    if (rows?.length) {
      setProductType(rows[0]?.ProductType?.Key);
    }
  }, [rows]);

  const referenceData = useGetSalesItemAttributeReferenceData(productType);
  const initialTableSettings = useInitialTableSettings({ tableName: "SalesItemAttributesTable" + editId, idPath }, rows);

  const columns: GridColDef[] = React.useMemo(() => {
    return [
      {
        field: "Attribute_Value",
        headerName: "Attribute Name",
        valueGetter: tableHelper.getFieldKeyOrValue,
        minWidth: 150,
        flex: 1,
      },
      {
        field: "AttributeValue",
        headerName: "Attribute Value",
        minWidth: 240,
        flex: 1,
        editable: true,
        valueFormatter: (value) => addLeadingZeroIfNeeded(value),
        renderEditCell: (params) => (
          <AttibuteInputCell
            params={params}
            referenceData={referenceData}
            attributesToUpdate={attributesToUpdate}
            setAttributesToUpdate={setAttributesToUpdate}
          />
        ),
      },
      { field: 'DisplayUnit', headerName: 'Display Unit' },
      { field: 'EntryUnit', headerName: 'EntryUnit' },
      { field: 'AttributeDescription', headerName: 'Description' },
      { field: 'AttributeGroupName', headerName: 'Group Name' },
      { field: 'Comment', headerName: 'Comment' },
      { field: 'AttributeDataType_Value', headerName: 'Data Type', valueGetter: tableHelper.getFieldKeyOrValue },
      { field: 'AttributeDataType_Key', headerName: 'AttributeDataType Id', valueGetter: tableHelper.getFieldKeyOrValue, width: 50, type: "number" },
      { field: 'AttributeGroupId', headerName: 'Group Id', type: "number" },
      { field: 'ProductType_Key', headerName: 'Product Type', valueGetter: tableHelper.getFieldKeyOrValue },
      { field: 'IsPostfix', headerName: 'Is Post fix', type: "boolean", width: 50 },
      { field: 'Attribute_Key', headerName: 'Attribute Id', valueGetter: tableHelper.getFieldKeyOrValue, width: 50, type: "number" },
    ];
  }, [
    referenceData,
    attributesToUpdate,
    initialTableSettings.apiRef,
  ]);

  const tableSettings = useCompleteTableSettings({ columns }, initialTableSettings);

  tableSettings.hasToolbar = false;
  tableSettings.autoHeight = true;

  useEffect(() => {
    tableSettings.setColumnVisibilityModel({
      AttributeDataType_Key: false,
      AttributeGroupId: false,
      ProductType_Key: false,
      IsPostfix: false,
      Attribute_Key: false,
    });
  }, []);

  return [columns, tableSettings, attributesToUpdate, applySavedAttributes];
};






const imageIdComparator = (v1, v2) => {
  // Function to extract the 'id' attribute from the HTML string
  const extractId = (htmlString) => {
    const match = /<img.*?id="([^"]*)".*?>/.exec(htmlString);
    return match ? match[1] : '';
  };

  const id1 = extractId(v1);
  const id2 = extractId(v2);

  return id1.localeCompare(id2);
};

const ImageFilterInputComponent = ({ item, applyValue }) => {
  const handleSelectChange = (event) => {
    applyValue({ ...item, value: event.target.value });
  };

  return (
    <Select
      value={item.value ?? ''}
      onChange={handleSelectChange}
      style={{ width: '100%' }}
    >
      <MenuItem value="">All</MenuItem>
      <MenuItem value="true">With Image</MenuItem>
      <MenuItem value="false">Without Image</MenuItem>
    </Select>
  );
};


const customThumbnailFilterOperator = {
  label: 'Has Image',
  value: 'hasImage',
  getApplyFilterFn: (filterItem) => {
    return (params) => {
      // Assuming that params.value is used to determine if an image is present
      const hasImage = params.value !== null && params.value !== '';
      if (filterItem.value === 'true') {
        return hasImage;
      } else if (filterItem.value === 'false') {
        return !hasImage;
      } else {
        return true; // For 'All' option
      }
    };
  },
  InputComponent: ImageFilterInputComponent,
  // Define your input component for this filter
  // You can make it a simple select with 'true' and 'false' options
};
